import { useFormContext } from "react-hook-form";
import { Button, ButtonGroup } from "@shopify/polaris";
import cardStyles from "../VolumeFormPreviewWrapper/VolumeBundleTemplate.module.css";
import { volTempColor } from "../VolumeFormPreviewWrapper/VolumeBundleTemplate";
import BrandColorPicker from "./BrandColorPicker";

interface VolumeThemeColorPickerProps {
    disabled?: boolean;
}

const VolumeThemeColorPicker = ({ disabled = false }: VolumeThemeColorPickerProps) => {
    const { setValue, getValues } = useFormContext();

    const handleChangeBundleDesign = (colorKey: keyof typeof volTempColor) => {
        const newBundleDesign: any = volTempColor[colorKey];
        const currentBundlesDesign = getValues("bundles_design") || {};
        setValue("bundles_design", { ...currentBundlesDesign, ...newBundleDesign }, { shouldDirty: true });
    };

    return (
        <div className={cardStyles.colorWrapper} style={{ justifyContent: "flex-end", paddingBlock: 0 }}>
            <h6 className={cardStyles.colorWrapperTitle}>Theme Color</h6>
            <div style={{ display: "flex", gap: "10px", position: "relative" }}>
                <ButtonGroup variant="segmented" noWrap>
                    {Object.keys(volTempColor).map((t: any) => (
                        <Button key={t} size="micro" disabled={disabled} onClick={() => handleChangeBundleDesign(t)}>
                            {/* @ts-expect-error no react elements allowed */}
                            <div style={{ backgroundColor: t }} className={cardStyles.colorBtn}></div>
                        </Button>
                    ))}

                    <BrandColorPicker disabled={disabled} />
                </ButtonGroup>
            </div>
        </div>
    );
};

export default VolumeThemeColorPicker;
